<template>
  <div class="card sidebar-menu list-group list-group-flush bg-bright p-3 mt-3">
    <router-link
      v-for="item in leftMenu"
      v-bind:key="item.id + Math.random(1024)"
      :to="item.link"
      :class="`menu-item ${active == item.value ? 'active' : ''}`"
      :data-value="item.value"
    >
      <!-- <i class="menu-item-icon material-symbols-outlined">{{item.icon}}</i> -->
      <span class="menu-item-text">{{ item.label }}</span>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "LeftMenuRl",
  props: {
    active: String,
  },
  data: function () {
    return {
      leftMenu: [
        { icon: "", label: "RL 1", link: "/dashboard/rl/", value: "rl", id: 1 },
        {
          icon: "",
          label: "RL 2",
          link: "/dashboard/rl2/",
          value: "rl2",
          id: 2,
        },
        {
          icon: "",
          label: "RL 3",
          link: "/dashboard/rl3/",
          value: "rl3",
          id: 3,
        },
        {
          icon: "",
          label: "RL 4 ",
          link: "/dashboard/rl4/",
          value: "rl4",
          id: 4,
        },
        {
          icon: "",
          label: "RL 5",
          link: "/dashboard/rl5/",
          value: "rl5",
          id: 5,
        },
      ],
    };
  },
};
</script>

